import { attachStatus } from './../request';
export default {
  data() {
    return {
      dialogVisible: false,
      list: [],
      type: '',
      id: ''
    };
  },
  methods: {
    init(arr, type, id) {
      this.list = arr;
      this.type = type;
      this.id = id;
      this.dialogVisible = true;
    },
    async handleSure() {
      await attachStatus({
        insuranceAttachId: this.id,
        status: 0,
        change: true
      });
      this.$message.success(this.$t('操作成功') + '!');
      this.$emit('ok');
      this.$emit('cancel');
    }
  }
};